export default "__VITE_ASSET__Cnj24XuA__"